import {
  DTOElementPropertyValueListResponse,
  DTOElementPropertyValueResponse,
  DTOElementPropertyValueUpsertPaylod,
} from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class ElementPropertyValuesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(designSystemId: string, versionId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/element-properties/values`,
      DTOElementPropertyValueListResponse
    );
  }

  upsert(designSystemId: string, versionId: string, body: DTOElementPropertyValueUpsertPaylod) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/element-properties/values`,
      DTOElementPropertyValueResponse,
      { method: "POST", body }
    );
  }
}
